import { defineComponent as D, computed as o, openBlock as n, createBlock as y, unref as i, withCtx as C, createElementBlock as u, toDisplayString as c, createCommentVNode as s, createElementVNode as I, mergeProps as k } from "vue";
import { RevInputText as L } from "@ds/components/InputText";
import x from "../../icons/generated/IconCalendar.vue2.js";
import { useLocale as q } from "@ds/plugin";
const w = {
  key: 0,
  class: "text-static-default-low caption mt-8"
}, A = { key: 0 }, N = /* @__PURE__ */ D({
  name: "RevInputDate",
  __name: "InputDate",
  props: {
    clearButtonAriaLabel: { default: void 0 },
    description: { default: void 0 },
    disabled: { type: Boolean },
    enteredDateLabel: { default: void 0 },
    hasClearButton: { type: Boolean, default: !0 },
    error: { default: void 0 },
    id: {},
    label: {},
    modelValue: {},
    pickedDateAttrs: {},
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "invalid", "valid", "clear"],
  setup(e, { emit: m }) {
    const l = e, a = m, f = q(), d = o(() => !!l.modelValue), r = o(
      () => typeof l.enteredDateLabel < "u"
    ), v = o(() => {
      if (!d.value)
        return;
      const t = l.modelValue;
      return new Intl.DateTimeFormat(f.value, {
        dateStyle: "long",
        timeZone: "UTC"
      }).format(new Date(t));
    }), b = (t) => {
      a("update:modelValue", t);
    }, p = (t) => {
      a("input", t);
    }, h = (t) => {
      a("invalid", t);
    }, V = () => {
      a("valid");
    }, B = () => {
      a("clear");
    };
    return (t, g) => (n(), y(i(L), {
      id: e.id,
      class: "relative cursor-text",
      "clear-button-aria-label": e.clearButtonAriaLabel,
      description: e.description,
      disabled: e.disabled,
      error: e.error,
      "has-clear-button": e.hasClearButton,
      icon: i(x),
      label: e.label,
      "model-value": e.modelValue,
      required: e.required,
      type: "date",
      onClear: B,
      onInput: p,
      onInvalid: h,
      "onUpdate:modelValue": b,
      onValid: V
    }, {
      default: C(() => [
        d.value ? (n(), u("div", w, [
          r.value ? (n(), u("span", A, c(e.enteredDateLabel), 1)) : s("", !0),
          I("span", k(e.pickedDateAttrs, {
            class: { "ml-2": r.value }
          }), c(v.value), 17)
        ])) : s("", !0)
      ]),
      _: 1
    }, 8, ["id", "clear-button-aria-label", "description", "disabled", "error", "has-clear-button", "icon", "label", "model-value", "required"]));
  }
});
export {
  N as default
};
